import * as actionTypes from 'constants/actionTypes';
import createReducer from 'reducers/createReducer';
import initialState from './initialState';

export default createReducer(initialState, {
  [actionTypes.LOADER__START]: state => state.set('loading', true),
  [actionTypes.LOADER__STOP]: state => state.set('loading', false)
});
